const colors = require("../../src/styles/colors");

module.exports = {
  siteTitle: "あんばらぼ", // <title>
  shortSiteTitle: "あんばらぼ", // <title> ending for posts and pages
  siteDescription: "あんばらのブログ",
  siteUrl: "https://awesome-anbalab.netlify.com/",
  pathPrefix: "",
  siteImage: "prepre.jpg",
  siteLanguage: "ja",
  // author
  authorName: "anbara",
  authorTwitterAccount: "ISM__M",
  // info
  infoTitle: "anbalab",
  infoTitleNote: "anbara's blog",
  // manifest.json
  manifestName: "あんばらぼ",
  manifestShortName: "あんばらぼ", // max 12 characters
  manifestStartUrl: "/",
  manifestBackgroundColor: colors.background,
  manifestThemeColor: colors.background,
  manifestDisplay: "standalone",
  // contact
  contactEmail: "",
  // social
  authorSocialLinks: [
    { name: "github", url: "https://github.com/anbara" },
    { name: "twitter", url: "https://twitter.com/ism__m" },
  ]
};



// WEBPACK FOOTER //
// ./content/meta/config.js